// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__2xnOZ","filled":"IconReviewStar_filled__3N9A9"};